import FAQGenerator from "../FAQGenerator/FAQGenertor";
import InfoBlock from "../InfoBlock/InfoBlock";
import MainBlock from "../MainBlock/MainBlock";
import StyleExamples from "../StyleExamples/StyleExamples";
import FileInput from "../FileInput/FileInput";
import { styleExamplesData } from "../constants.js";
import TryOurTools from "../../tryOurTools/tryOurTools.jsx";
import UploadYourFile from "../../tryAITool/tryAITool.jsx";
import ExamplesWrapper from "../../examples/examplesWrapper/examplesWrapper.jsx";

function GeneratorLayout({ dictionary, uploadFile, isLoading, checkNonAuth = () => {} }) {
	const mainBlockData = {
		title: "photo_into_painting",
		description: "Create awesome painting from your picture with AI",
		videoUrl: "/photo_into_painting/photo_into_painting.mp4",
		posterUrl: "/photo_into_painting/photo_into_painting.png",
	};

	return (
		<>
			<MainBlock dictionary={dictionary} mainBlockData={mainBlockData}>
				<FileInput uploadFile={uploadFile} dictionary={dictionary} isLoading={isLoading} creditCost={"1_credit"} checkNonAuth={checkNonAuth} />
			</MainBlock>
			<ExamplesWrapper type="photo" t={dictionary} />
			<InfoBlock dictionary={dictionary} />
			<StyleExamples dictionary={dictionary} styleExamplesData={styleExamplesData} />
			<UploadYourFile dictionary={dictionary} />
			<FAQGenerator dictionary={dictionary} />
			<TryOurTools t={dictionary} />
		</>
	);
}

export default GeneratorLayout;
